import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import SymbolClz from 'echarts/lib/chart/helper/Symbol';
import { Element } from 'zrender';
import { eachLineSeriesModel } from './helper';
import type { DvLineSeriesModel } from './type';

interface SymbolExtended extends SymbolClz {
  __temp?: boolean;
}
function isVisibleColor(color?: unknown) {
  return color && color !== 'transparent';
}

function getFirstVisibleColor(colors: unknown[]) {
  for (let i = 0; i < colors.length; i++) {
    if (isVisibleColor(colors[i])) {
      return colors[i];
    }
  }
  return null;
}

function getLastIndexNotNull(points: ArrayLike<number>) {
  let len = points.length / 2;
  for (; len > 0; len--) {
    if (!(Number.isNaN(points[len * 2 - 2]) || Number.isNaN(points[len * 2 - 1]))) {
      break;
    }
  }

  return len - 1;
}

function parseBreathPoint(model: DvLineSeriesModel) {
  if (!model.get('dvShowBreathPoint')) {
    return;
  }

  const data = model.getData();
  const points = data.getLayout('points') as ArrayLike<number>;
  const lastIndex = getLastIndexNotNull(points);
  const lastSymbol = data.getItemGraphicEl(lastIndex);

  if (!lastSymbol) {
    return;
  }

  const symbolPath = lastSymbol.getSymbolPath() as Element;
  const symbolStyle = data.getItemVisual(lastIndex, 'style');
  const symbolShadowColor = getFirstVisibleColor([
    symbolStyle.shadowColor,
    symbolStyle.fill,
    symbolStyle.stroke
  ]);

  if (!symbolShadowColor) {
    return;
  }

  const exhaleTime = 600;
  const inhaleTime = 900;
  const exhaleShadowBlur = 20;
  const inhaleShadowBlur = 10;
  symbolPath
    .animate('style', true)
    .when(exhaleTime, {
      shadowColor: symbolShadowColor,
      shadowBlur: exhaleShadowBlur
    })
    .when(inhaleTime, {
      shadowColor: symbolShadowColor,
      shadowBlur: inhaleShadowBlur
    })
    .start();

  symbolPath.stateTransition.done = () => {
    if (symbolPath.currentStates.includes('emphasis')) {
      symbolPath
        .animate('style', true)
        .when(exhaleTime, {
          shadowColor: '#red',
          shadowBlur: exhaleShadowBlur
        })
        .when(inhaleTime, {
          shadowColor: '#red',
          shadowBlur: inhaleShadowBlur
        })
        .start();
    }
  };
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:afterupdate', (ecModel, api) => {
    eachLineSeriesModel(ecModel, model => {
      parseBreathPoint(model);
    });
  });
}
